import { HandlerEvent } from 'post-robot';
import { refreshThmProfilingPromise } from 'communicator/utils/thm';
import { postmessageToParent } from 'communicator/utils/visa-sdk';

/**
 * Merchant SDK integrations expect a 'success' event from the system-sdk
 * iframe, so when visa-sdk receives a merchant-transaction-success event from
 * the app, we relay the message to communicator, which postmessages back to the
 * merchant-sdk.
 */
export default function visaSrciSuccess(event: HandlerEvent<Record<string, unknown>>) {
  refreshThmProfilingPromise();

  postmessageToParent({
    type: 'success',
    data: event.data
  });
}
